import { render, staticRenderFns } from "./PublishingCard.vue?vue&type=template&id=bd7311a4&scoped=true"
import script from "./PublishingCard.vue?vue&type=script&lang=js"
export * from "./PublishingCard.vue?vue&type=script&lang=js"
import style0 from "./PublishingCard.vue?vue&type=style&index=0&id=bd7311a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7311a4",
  null
  
)

export default component.exports